module.exports = __webpack_public_path__ + "auction.png?dbd366ba84a47330a91e8e8858968fa6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auction.png
// module id = 96
// module chunks = 0